var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('a-authorization-card',{staticClass:"ma-5",attrs:{"color":"secondary","icon":"mdi-arrow-decision","title":"Accrochez-vous !","text":"Vous allez être redirigé vers le serveur d'authentification.","sub":"Cela peut prendre quelques instants."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }